const actionTypes = {
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
}

export default actionTypes
